import React, { useContext, useState,useEffect } from "react";
import "../header/Header.scss";
import Userinfo from "../user/Userinfo";
import { ThemeContext } from "../../context/ThemeContext";
import { AuthContext } from "../../context/AuthContext";
import logo from "../../assets/images/logo.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import SunIcon from "../../assets/icons/SunIcon";
import MoonIcon from "../../assets/icons/MoonIcon";

const Header = ({ headerpageTitle , isDateEnabled }) => {
  const { toggleTheme, theme, showMenu, toggleMenu } = useContext(ThemeContext);
  const { handleLogout, dateChange, setDateChange } = useContext(AuthContext);
  const [startDate, setStartDate] = useState(new Date());
  useEffect(() => {
    //setStartDate( new Date());
    setDateChange( new Date());
  }, [headerpageTitle]);

  // Custom date format function
  const customDateFormat = (date) => {
    return format(date, "MMM dd, EEE YYYY");
  };

  return (
    <header className="layout-header">
      <div className="left-head">
        <div className="toggle-btn" onClick={toggleMenu}>
          <div className="zea-icons menu hambuger"></div>
        </div>
        <div className="title-head">
          <h3 className="page-title">{headerpageTitle}</h3>
        </div>
      </div>
      <div className="center-head">
        <div className="logo-area">
          <img className="menu-logo" src={logo} alt="" />
        </div>
      </div>
      <div className="right-head">
        <div className="date">
          <DatePicker
            selected={dateChange}
            onChange={(date) => setDateChange(date)}
            dateFormat="MMM dd, EEE YYYY" // This adds the custom format directly
            disabled={!isDateEnabled}
          />
        </div>
        <button className="theme-switch" onClick={toggleTheme}>
          {theme !== "light" ? <SunIcon/> : <MoonIcon/>}
        </button>
        {/*<div className="notification">
          <button className="new">
            <svg width="20.903" height="23" viewBox="0 0 20.903 23">
              <g
                id="Icon_feather-bell"
                data-name="Icon feather-bell"
                transform="translate(-3.5 -2)"
              >
                <path
                  id="Path_4"
                  data-name="Path 4"
                  d="M20.253,9.3a6.3,6.3,0,0,0-12.6,0c0,7.351-3.151,9.452-3.151,9.452H23.4s-3.151-2.1-3.151-9.452"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  id="Path_5"
                  data-name="Path 5"
                  d="M19.039,31.5a2.1,2.1,0,0,1-3.634,0"
                  transform="translate(-3.27 -8.546)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </svg>
          </button>
        </div>
        */}
        <Userinfo onThemeToggle={toggleTheme} onLogout={handleLogout} />
      </div>
    </header>
  );
};

export default Header;
